"use client";

import { type FC, type Ref, useMemo } from "react";
import {
  Button,
  type UIAction,
  useActions,
  Flex,
  Text,
  Card,
  Chip,
  Icon,
} from "@huub-web/ui";

import { useTemplates } from "../../hooks/useTemplates";
import { usePageContent } from "../../hooks/usePageContent";

export interface ConsultationCardTemplateProps {
  title?: string;
  description?: string;
  cta?: string;
  action?: UIAction;
  initialConsultation?: boolean;
}

export const ConsultationCardTemplate: FC<
  ConsultationCardTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ title, description, cta, action, initialConsultation = false, ref }) => {
  const { handleAction } = useActions();
  const { lockUI } = useTemplates();

  const contentItem = useMemo(
    () =>
      cta
        ? {
            type: "cta" as const,
            label: cta,
            ...(title ? { description: title } : {}),
            ...(action ? { action } : {}),
          }
        : null,
    [cta, title, action],
  );
  usePageContent("consultation", contentItem);

  const handleClick = () => {
    if (action) {
      handleAction(action);
    }
  };

  return (
    <Card
      ref={ref}
      as="section"
      variant="tertiary"
      padding="xl"
      overflowHidden
      // leading={
      //   variant === "gradient" && <GraphicsContainer variant="banner" />
      // }
    >
      {initialConsultation && (
        <Chip
          size="l"
          leading={<Icon icon="microphone" size="s2" />}
          variant="currentColor"
          alignSelf="flex-start"
        >
          30 min • vrijblijvend
        </Chip>
      )}
      <Flex direction="column" gap="xs">
        <Text as="h3" variant="displayM" bold>
          {title}
        </Text>
        <Text as="p">{description}</Text>
      </Flex>
      {cta && (
        <Button
          onClick={handleClick}
          variant="primary"
          size="s"
          alignSelf="flex-start"
          disabled={lockUI}
        >
          {cta}
        </Button>
      )}
    </Card>
  );
};
